import { getProfileIdModelUtil } from '../../../utils/get-profile-id'
import { PROFILE_LOGS_PATH } from '../../../../modules/profile-logs/constants/path'
import getByProfileIdDomainListPathReduxUtil from '../../../../modules/redux/utils/get-by-profile-id-domain-list-path'
import getByProfileIdDataPeriodDomainListPathsReduxUtil from '../../../../modules/redux/utils/get-by-profile-id-data-period-domain-list-paths'

function getDomainListPathsProfileLogUtil (instance, state) {
  const profileId = getProfileIdModelUtil(instance)
  const domainListPaths = []
  domainListPaths.unshift(getByProfileIdDomainListPathReduxUtil(
    PROFILE_LOGS_PATH.ALL,
    profileId
  ))
  return [
    ...domainListPaths,
    ...getByProfileIdDataPeriodDomainListPathsReduxUtil({
      instance,
      state
    })
  ]
  // domainListPaths.push(
  //   getByProfileIdDomainListPathReduxUtil(
  //     getByMonthDomainListPathProfileLogUtil(instance),
  //     profileId
  //   )
  // )
  // domainListPaths.push(
  //   getByProfileIdDomainListPathReduxUtil(
  //     getByWeekDomainListPathProfileLogUtil(instance),
  //     profileId
  //   )
  // )
  // domainListPaths.push(
  //   getByProfileIdDomainListPathReduxUtil(
  //     getByDayDomainListPathProfileLogUtil(instance),
  //     profileId
  //   )
  // )
}

export {
  getDomainListPathsProfileLogUtil
}
